/**
 * Created on 2025-08-11.
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'curr-privacy-policy-content',
  templateUrl: './privacy-policy-content.component.html',
  styleUrls: ['./privacy-policy-content.component.scss']
})
export class PrivacyPolicyContentComponent {}
